import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M10.956 18.003c-.307 0-.617-.066-.906-.202-.648-.306-1.05-.913-1.05-1.586V7.789c0-.673.402-1.28 1.05-1.586a2.09 2.09 0 0 1 2.209.259l5.099 4.214c.409.336.642.82.642 1.326s-.233.99-.642 1.326l-5.099 4.213a2.04 2.04 0 0 1-1.303.462",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }